import axiosInstance from "../axiosConfig";
import { ICreateOrder } from "./Interfaces";

export const createOrder = (props: ICreateOrder) => {
  return { url: `/orders`, props };
};

export const getOrder = (orderId: string) => {
  return { url: `/orders/${orderId}`}
}